<div class="py-3 px-4 contract-sign-form rounded-bottom">
  <form [formGroup]="form" class="row" #formSign>
    <cdk-form-group class="pt-0 col-12 col-sm-6">
      <div class="d-flex">
        <label class="text-gray-900"> Signature </label>
        <span
          styleClass="ps-1 icon-info"
          cdkIcon="outlined"
          matTooltip="Enter name of person with authority to contract on behalf of the entity"
          matTooltipPosition="above"
          >info</span
        >
      </div>
      <input
        type="text"
        cdkInput
        inputRestriction="onlyText"
        [placeholder]="namePlaceholder || 'E.g. John Doe'"
        formControlName="signature" />
      <cdk-error *ngIf="controlHasError(form, 'signature', 'required')"
        >This field is required</cdk-error
      >
    </cdk-form-group>
    <cdk-form-group class="pt-0 col-12 col-sm-6">
      <div class="d-flex">
        <label class="text-gray-900"> Printed name </label>
        <span
          styleClass="ps-1 icon-info"
          cdkIcon="outlined"
          matTooltip="Enter name of person with authority to contract on behalf of the entity"
          matTooltipPosition="above"
          >info</span
        >
      </div>
      <input
        type="text"
        cdkInput
        inputRestriction="onlyText"
        [placeholder]="namePlaceholder || 'E.g. John Doe'"
        formControlName="printedName" />
      <cdk-error *ngIf="controlHasError(form, 'printedName', 'required')"
        >This field is required</cdk-error
      >
    </cdk-form-group>
    <cdk-form-group class="pt-0 col-12 col-sm-6 mt-0 mt-sm-3">
      <label class="text-gray-900"> NPN </label>
      <input
        type="tel"
        cdkInput
        inputRestriction="onlyNumbers"
        [placeholder]="lead?.NPN__c || 'E.g.123456'"
        formControlName="npn" />
      <cdk-error *ngIf="controlHasError(form, 'npn', 'required')"
        >This field is required</cdk-error
      >
      <cdk-error
        *ngIf="form.get('npn').value && controlHasError(form, 'npn', 'equals')"
        >This value is invalid</cdk-error
      >
    </cdk-form-group>
    <cdk-form-group class="pt-0 col-12 col-sm-6 mt-0 mt-sm-3">
      <label class="text-gray-900"> Title </label>
      <input
        type="text"
        cdkInput
        placeholder="E.g manager, director, etc."
        formControlName="title" />
      <cdk-error *ngIf="controlHasError(form, 'title', 'required')"
        >This field is required</cdk-error
      >
    </cdk-form-group>
  </form>
</div>
